<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>设备列表</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formInline" class="user-search">
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">录入新设备</el-button>
                <el-button size="small" type="info" icon="el-icon-edit" @click="batchEdit()">批量编辑</el-button>
                <el-button size="small" type="warning" icon="el-icon-edit" @click="batchMove()">批量移动</el-button>
                <el-button size="small" type="danger" icon="el-icon-remove" @click="batchDelete()">删除</el-button>
                <el-button size="small" type="success" icon="el-icon-play" @click="batchPlay()">启动</el-button>
                <el-button size="small" type="danger" icon="el-icon-stop" @click="batchStop()">停止</el-button>
                <el-button size="small" type="success" icon="el-icon-auto" @click="batchAuto()">自动</el-button>
                <el-button size="small" type="primary" icon="el-icon-hand" @click="batchHand()">手动</el-button>
                <el-button size="small" type="danger" icon="el-icon-lock" @click="batchLock()">锁定</el-button>
                <el-button size="small" type="primary" icon="el-icon-unlock" @click="batchUnLock()">解锁</el-button>
            </el-form-item>
        </el-form>
        <!--列表-->
        <el-table size="small" ref="deviceTable" :data="(listData && listData.devices) ? listData.devices : []" highlight-current-row
                  v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column align="center" type="selection" width="60"></el-table-column>
            <el-table-column prop="name" label="设备名称"></el-table-column>
            <el-table-column prop="serial" label="设备序号" max-width="50"></el-table-column>
            <el-table-column prop="gname" label="所属分组"></el-table-column>
            <el-table-column sortable prop="imei" label="设备IMEI"></el-table-column>
            <el-table-column prop="sort" label="报警信息">
                <template slot-scope="scope">
                    {{scope.row.anum > '0' ? scope.row.anum : '-'}}
                </template>
            </el-table-column>
            <el-table-column prop="channel_type" label="操作类型">
                <template slot-scope="scope">
                    {{scope.row.operation_type == '1' ? '手动' : '自动'}}
                </template>
            </el-table-column>
            <el-table-column prop="status" label="设备状态">
                <template slot-scope="scope">
                    <div class="status" v-if="scope.row.status == 0">
                        <div class="red-bg"></div>
                        <span class="status-close">关闭</span>
                    </div>
                    <div class="status" v-else-if="scope.row.status == 1">
                        <div class="green-bg"></div>
                        <span class="status-run">运行</span>
                    </div>
                    <div class="status" v-else-if="scope.row.status == 2">
                        <div class="grey1-bg"></div>
                        <span class="status-leave">离线</span>
                    </div>
                    <div class="status" v-else-if="scope.row.status == 3">
                        <div class="orange-bg"></div>
                        <span class="status-alarm">故障</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column align="center" label="操作" min-width="150">
                <template slot-scope="scope">
                    <el-button size="mini" @click="handleEdit(scope.row)">详情</el-button>
                    <el-button size="mini" type="danger" @click="deleteDevice(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        <!-- 编辑界面 -->
        <el-dialog :title="title" :visible.sync="editFormVisible" width="70%" @click="closeDialog">
            <div>
                <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
                    <div>
                        <p class="base-title">基本信息</p>
                    </div>
                    <el-form-item label="设备名称" prop="name" :required="true" style="margin-left: -40px;">
                        <el-input size="small" v-model="editForm.name" auto-complete="off" style="width: 30%;"
                                  placeholder="请输入设备名称"></el-input>
                    </el-form-item>

                    <el-form-item label="所属分组" prop="group_id" :required="true" style="margin-left: -40px;">
                        <el-select v-model="editForm.group_id" placeholder="请选择分组" style="width: 30%;">
                            <el-option
                                    v-for="item in groups"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="设备IMEI" prop="imei" :required="true" style="margin-left: -40px;">
                        <el-input size="small" v-model="editForm.imei" auto-complete="off" style="width: 30%;"
                                  placeholder="请输入IMEI"></el-input>
                    </el-form-item>

                    <div>
                        <p class="base-title">设备标记</p>
                        <div class="device-map">
                            <iframe id="mapPage"
                                    src="https://apis.map.qq.com/tools/locpicker?search=1&type=1&key=RFEBZ-X2OAW-24YRK-OZTHE-FQTY5-B7BCY&referer=myapp&total=10"
                                    frameborder="0" width="100%" height="500"></iframe>
                        </div>
                    </div>

                    <div slot="footer" class="dialog-footer">
                        <el-button size="small" @click="closeDialog">取消</el-button>
                        <el-button size="small" type="primary" :loading="loading" class="title"
                                   @click="submitForm('editForm')">
                            保存
                        </el-button>
                    </div>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="closeDialog">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">
                    保存
                </el-button>
            </div>
        </el-dialog>

        <el-dialog title="设备详情" :visible.sync="editDeviceFormVisible" width="70%" @click="closeDetailDialog">
            <div>
                <el-form label-width="120px" :model="editDetailForm" :rules="rules" ref="editDetailForm">
                    <div class="group-base">
                        <div class="base-title">实时参数</div>
                        <div class="param-info">
                            <div class="params-list"><span>电压（V）</span><span>{{editDetailForm.electricPower}}</span>
                            </div>
                            <div class="params-list"><span>水位</span><span>{{editDetailForm.waterPosition}}</span></div>
                            <div class="params-list"><span>水压（MPa）</span><span>{{editDetailForm.waterPower}}</span>
                            </div>
                            <div class="params-list"><span>剩余机油时间（H）</span><span>{{editDetailForm.oilTime}}</span></div>
                            <div class="params-list"><span>电流（A）</span><span>{{editDetailForm.current}}</span></div>
                            <div class="params-list"><span>累计运行时间（H）</span><span>{{editDetailForm.runTime}}</span></div>
                        </div>

                        <div class="base-title">基本信息</div>
                        <div class="device-detail">
                            <el-form-item label="设备名称" prop="name" :required="true" style="margin-left: -40px;">
                                <el-input size="small" v-model="editDetailForm.name" auto-complete="off"
                                          placeholder="请输入设备名称" style="width: 30%;"></el-input>
                            </el-form-item>
                            <div style="margin-left: 4.2vw;margin-top: -3vh;margin-bottom: 3vh;">
                                设备序号 <span class="blue">{{editDetailForm.serial}}</span>
                            </div>

                            <el-form-item label="所属分组" prop="group_id" :required="true" style="margin-left: -40px;">
                                <el-select v-model="editDetailForm.group_id" placeholder="请选择分组"
                                           style="width: 30%;">
                                    <el-option
                                            v-for="item in groups"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>

                            <div class="layui-form-item">
                                <label>设备IMEI</label>
                                <span class="text-display" style="margin-left: 20px;">{{editDetailForm.imei}}</span>
                            </div>

                            <div class="layui-form-item">
                                <label class="layui-form-label col-sm-1">经纬度</label>
                                <span class="text-display" style="margin-left: 35px;">{{editDetailForm.longitude}}，{{editDetailForm.latitude}}</span>
                            </div>

                            <div class="layui-form-item">
                                <label class="layui-form-label col-sm-1">报警信息</label>
                                <span class="text-display">{{editDetailForm.alarm != '' ? editDetailForm.alarm : '无'}}</span>
                            </div>
                        </div>

                        <div class="base-title">参数设定</div>
                        <div class="device-detail">
                            <div style="display:flex; margin-left: -40px;">
                                <el-form-item label="设定压力" prop="pressure" :required="true"
                                              style="width: 34%;margin-right: 20px;">
                                    <el-input size="small" v-model="editDetailForm.pressure" auto-complete="off"
                                              placeholder="请设置压力"></el-input>
                                </el-form-item>
                                <span class="mpa">MPa</span>
                            </div>
                            <el-form-item label="间歇运行" prop="run_time" :required="true"
                                          style="width: 35%;margin-right: 20px;margin-left: -40px;">
                                <el-time-picker v-model="editDetailForm.run_time" format="HH:mm:ss"
                                                value-format="HH:mm:ss"
                                                :picker-options="{selectableRange: '00:00:00 - 23:59:59'}"
                                                placeholder="请选择运行时间"></el-time-picker>
                            </el-form-item>
                            <el-form-item label="间歇停止" prop="stop_time" :required="true"
                                          style="width: 35%;margin-right: 20px;margin-left: -40px;">
                                <el-time-picker v-model="editDetailForm.stop_time" format="HH:mm:ss"
                                                value-format="HH:mm:ss"
                                                :picker-options="{selectableRange: '00:00:00 - 23:59:59'}"
                                                placeholder="请选择停止时间"></el-time-picker>
                            </el-form-item>

                            <div class="layui-form-item" style="margin-left: -40px;">
                                <el-form-item label="操作模式" prop="mode" :required="true">
                                    <el-select v-model="editDetailForm.mode" placeholder="请选择操作模式" style="width: 30%;">
                                        <el-option
                                                v-for="item in mode"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </div>
                    </div>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="closeDetailDialog">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" class="title"
                           @click="submitDetailForm('editDetailForm')">
                    保存
                </el-button>
            </div>
        </el-dialog>

        <!--批量编辑-->
        <el-dialog title="参数编辑" :visible.sync="editBatchFormVisible" width="60%" @click="closeBatchDialog">
            <div>
                <el-form label-width="120px" :model="editBatchForm" :rules="rulesBatch" ref="editBatchForm">
                    <el-form-item label="设定压力" prop="pressure" :required="true">
                        <el-input size="small" v-model="editBatchForm.pressure" auto-complete="off"
                                  placeholder="请输入压力"></el-input>
                    </el-form-item>
                    <el-form-item label="间歇运行" prop="run_time" :required="true">
                        <el-input size="small" v-model="editBatchForm.run_time" auto-complete="off"
                                  placeholder="请设定间歇运行时间"></el-input>
                    </el-form-item>
                    <el-form-item label="间歇停止" prop="stop_time" :required="true">
                        <el-input size="small" v-model="editBatchForm.stop_time" auto-complete="off"
                                  placeholder="请设定间歇停止时间"></el-input>
                    </el-form-item>
                    <el-form-item label="操作模式" prop="mode" :required="true">
                        <el-select v-model="editBatchForm.mode" placeholder="请选择操作模式">
                            <el-option
                                    v-for="item in mode"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="closeBatchDialog">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" class="title"
                           @click="submitBatchForm('editBatchForm')">
                    保存
                </el-button>
            </div>
        </el-dialog>

        <el-dialog title="批量移动" :visible.sync="editGroupFormVisible" width="50%" @click="closeGroupDialog">
            <div>
                <el-form label-width="120px" :model="editGroupForm" :rules="rulesBatch" ref="editGroupForm">
                    <el-form-item label="所属分组" prop="group_id" :required="true">
                        <el-select v-model="editGroupForm.gid" placeholder="请选择分组">
                            <el-option
                                    v-for="item in groups"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="closeGroupDialog">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" class="title"
                           @click="submitGroupForm('editGroupForm')">
                    保存
                </el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
    import {
        batchAutos,
        batchEdits,
        batchHands,
        batchMoves,
        batchPlays,
        batchStops,
        deviceAdd,
        deviceDelete,
        deviceDetailParam,
        devices,
        groups
    } from '../../api/userMG'
    import Pagination from '../../components/Pagination'

    export default {
        data() {
            return {
                nshow: true, //switch开启
                fshow: false, //switch关闭
                loading: false, //是显示加载
                editFormVisible: false, //控制编辑页面显示与隐藏
                editBatchFormVisible: false, //批量编辑
                editGroupFormVisible: false, //分组移动
                editDeviceFormVisible: false,
                title: '添加',
                editForm: {
                    id: null,
                    name: '',
                    group_id: '',
                    imei: '',
                    lat: '',
                    lng: '',
                },
                groups: [],
                ids: [],
                editGroupForm: {
                    gid: '',
                },
                editDetailForm: {},
                editBatchForm: {
                    pressure: '',
                    mode: '',
                    run_time: '',
                    stop_time: '',
                },
                mode: [
                    {label: '远程&本地', value: 3},
                    {label: '远程', value: 2},
                    {label: '本地', value: 1},
                ],
                // rules表单验证
                rules: {
                    name: [
                        {required: true, message: '请输入设备名称', trigger: 'blur'}
                    ],
                    group_id: [
                        {required: true, message: '请选择分组', trigger: 'blur'}
                    ],
                    imei: [
                        {required: true, message: '请输入IMEI', trigger: 'blur'}
                    ],
                    lat: [
                        {required: true, message: '请选择设备地址', trigger: 'blur'}
                    ],
                    lng: [
                        {required: true, message: '请选择设备地址', trigger: 'blur'}
                    ]
                },
                rulesBatch: {
                    pressure: [
                        {required: true, message: '请输入压力', trigger: 'blur'}
                    ],
                    run_time: [
                        {required: true, message: '请输入运行时间', trigger: 'blur'}
                    ],
                    stop_time: [
                        {required: true, message: '请输入停止时间', trigger: 'blur'}
                    ],
                    mode: [
                        {required: true, message: '请选择操作模式', trigger: 'blur'}
                    ]
                },
                formInline: {
                    page: 1,
                    limit: 10,
                    pageSize: 10,
                },
                // 选择数据
                selectdata: [],
                listData: { devices: [] },
                // 分页参数
                pageparm: {
                    currentPage: 1,
                    pageSize: 10,
                    total: 10
                }
            }
        },
        // 注册组件
        components: {
            Pagination
        },
        /**
         * 数据发生改变
         */

        watch: {},

        /**
         * 创建完毕
         */

        created() {
            this.loading = true
            this.getdata(this.formInline)

            window.addEventListener('message', function (event) {
                // 接收位置信息，用户选择确认位置点后选点组件会触发该事件，回传用户的位置信息
                var loc = event.data;
                if (loc && loc.module == 'locationPicker') {
                    //防止其他应用也会向该页面post信息，需判断module是否为'locationPicker'
                    this.editForm.lat = loc.latlng.lat
                    this.editForm.lng = loc.latlng.lng
                }
            })
        },

        /**
         * 里面的方法只有被调用才会执行
         */
        methods: {
            // 获取数据方法
            getdata(parameter) {
                this.loading = false
                devices(parameter).then(res => {
                    if (res.code == 200) {
                        const payload = res.result || res.data || {}
                        const rows = Array.isArray(payload.devices)
                            ? payload.devices
                            : (Array.isArray(payload.items) ? payload.items : [])
                        this.listData = { devices: rows }
                        this.pageparm.currentPage = payload.page != null ? payload.page : this.formInline.page
                        this.pageparm.pageSize = payload.pageSize != null ? payload.pageSize : this.formInline.limit
                        const total = payload.count != null
                            ? payload.count
                            : (payload.pageInfo && payload.pageInfo.total != null ? payload.pageInfo.total : rows.length)
                        this.pageparm.total = total
                    }
                })

                groups().then(res => {
                    if (res.code == 200) {
                        this.groups = res.result
                    }
                })
            },
            // 分页插件事件
            callFather(parm) {
                this.formInline.page = parm.currentPage
                this.formInline.limit = parm.pageSize
                this.getdata(this.formInline)
            },
            //显示编辑界面
            handleEdit(row) {
                // 深拷贝并赋值
                if (row != undefined && row != 'undefined') {
                    this.editDeviceFormVisible = true
                    this.title = '修改设备'
                    this.editDetailForm = row
                } else {
                    this.editFormVisible = true
                    this.title = '添加设备'
                    this.editForm.name = ''
                    this.editForm.imei = ''
                    this.editForm.group_id = ''
                    this.editForm.lat = ''
                    this.editForm.lng = ''
                }
            },
            batchEdit() {
                let selectedRows = this.$refs.deviceTable.selection
                if (selectedRows.length == 0) {
                    this.$message.error('请先选择设备！')
                    return false;
                }
                this.editBatchFormVisible = true
                this.ids = selectedRows
            },
            batchMove() {
                let selectedRows = this.$refs.deviceTable.selection
                if (selectedRows.length == 0) {
                    this.$message.error('请先选择设备！')
                    return false;
                }
                this.editBatchForm.ids = selectedRows
            },
            batchDelete() {
                let selectedRows = this.$refs.deviceTable.selection
                if (selectedRows.length == 0) {
                    this.$message.error('请先选择设备！')
                    return false;
                }
                batchDelete({ids: selectedRows}).then(res => {
                    if (res.code == 200) {
                        this.$message.success('保存成功！')
                    } else {
                        this.$message.error('保存失败！')
                    }
                })
            },
            batchPlay() {
                let selectedRows = this.$refs.deviceTable.selection
                if (selectedRows.length == 0) {
                    this.$message.error('请先选择设备！')
                    return false;
                }
                let ids = []
                selectedRows.forEach(item => {
                    ids.push(item.id)
                })
                batchPlays({ids: ids, type: 'play'}).then(res => {
                    if (res.code == 200) {
                        this.$message.success('保存成功！')
                    } else {
                        this.$message.error('保存失败！')
                    }
                })
            },
            batchStop() {
                let selectedRows = this.$refs.deviceTable.selection
                if (selectedRows.length == 0) {
                    this.$message.error('请先选择设备！')
                    return false;
                }
                let ids = []
                selectedRows.forEach(item => {
                    ids.push(item.id)
                })
                batchStops({ids: ids, type: 'stop'}).then(res => {
                    if (res.code == 200) {
                        this.$message.success('保存成功！')
                    } else {
                        this.$message.error('保存失败！')
                    }
                })
            },
            batchAuto() {
                let selectedRows = this.$refs.deviceTable.selection
                if (selectedRows.length == 0) {
                    this.$message.error('请先选择设备！')
                    return false;
                }
                let ids = []
                selectedRows.forEach(item => {
                    ids.push(item.id)
                })
                batchAutos({ids: ids, type: 'auto'}).then(res => {
                    if (res.code == 200) {
                        this.$message.success('保存成功！')
                    } else {
                        this.$message.error('保存失败！')
                    }
                })
            },
            batchHand() {
                let selectedRows = this.$refs.deviceTable.selection
                if (selectedRows.length == 0) {
                    this.$message.error('请先选择设备！')
                    return false;
                }
                let ids = []
                selectedRows.forEach(item => {
                    ids.push(item.id)
                })
                batchHands({ids: ids, type: 'hand'}).then(res => {
                    if (res.code == 200) {
                        this.$message.success('保存成功！')
                    } else {
                        this.$message.error('保存失败！')
                    }
                })
            },
            batchLock() {
                let selectedRows = this.$refs.deviceTable.selection
                if (selectedRows.length == 0) {
                    this.$message.error('请先选择设备！')
                    return false;
                }
                let ids = []
                selectedRows.forEach(item => {
                    ids.push(item.id)
                })
                batchLocks({ids: ids, type: 'lock'}).then(res => {
                    if (res.code == 200) {
                        this.$message.success('保存成功！')
                    } else {
                        this.$message.error('保存失败！')
                    }
                })
            },
            batchUnLock() {
                let selectedRows = this.$refs.deviceTable.selection
                if (selectedRows.length == 0) {
                    this.$message.error('请先选择设备！')
                    return false;
                }
                let ids = []
                selectedRows.forEach(item => {
                    ids.push(item.id)
                })
                batchUnLocks({ids: ids, type: 'unlock'}).then(res => {
                    if (res.code == 200) {
                        this.$message.success('保存成功！')
                    } else {
                        this.$message.error('保存失败！')
                    }
                })
            },
            // 编辑、增加页面保存方法
            submitForm(editData) {
                this.$refs[editData].validate(valid => {
                    if (valid) {
                        deviceAdd(this.editForm)
                            .then(res => {
                                this.editFormVisible = false
                                this.loading = false
                                if (res.code == 200) {
                                    this.getdata(this.formInline)
                                    this.$message({
                                        type: 'success',
                                        message: '设备保存成功！'
                                    })
                                } else {
                                    this.$message({
                                        type: 'info',
                                        message: res.message
                                    })
                                }
                            })
                            .catch(err => {
                                this.editFormVisible = false
                                this.loading = false
                                this.$message.error('设备保存失败，请稍后再试！')
                            })
                    } else {
                        return false
                    }
                })
            },
            submitBatchForm(editData) {
                this.$refs[editData].validate(valid => {
                    if (valid) {
                        let ids = []
                        this.ids.forEach(item => {
                            ids.push(item.id)
                        })
                        this.editBatchForm.ids = ids
                        batchEdits(this.editBatchForm)
                            .then(res => {
                                this.editBatchFormVisible = false
                                this.loading = false
                                if (res.code == 200) {
                                    this.$message({
                                        type: 'success',
                                        message: '保存成功！'
                                    })
                                    this.ids = []
                                } else {
                                    this.$message({
                                        type: 'info',
                                        message: '保存失败！'
                                    })
                                }
                            })
                    } else {
                        return false
                    }
                })
            },
            submitGroupForm(editData) {
                this.$refs[editData].validate(valid => {
                    if (valid) {
                        let ids = []
                        this.ids.forEach(item => {
                            ids.push(item.id)
                        })
                        this.editBatchForm.ids = ids
                        batchMoves({ids: ids, gid: this.editGroupForm.gid}).then(res => {
                            this.editBatchFormVisible = false
                            this.loading = false
                            if (res.code == 200) {
                                this.$message({
                                    type: 'success',
                                    message: '保存成功！'
                                })
                                this.ids = []
                            } else {
                                this.$message({
                                    type: 'info',
                                    message: '保存失败！'
                                })
                            }
                        })
                    }
                })
            },
            submitDetailForm(editData) {
                deviceDetailParam(this.editDetailForm).then(res => {
                    if (res.code == 200) {
                        this.$message({
                            type: 'success',
                            message: '保存成功！'
                        })
                        this.getdata()
                        this.editDeviceFormVisible = false
                    }
                })
            },
            // 删除设备
            deleteDevice(row) {
                this.$confirm('确定要删除吗?', '信息', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        deviceDelete({id: row.id})
                            .then(res => {
                                if (res.code == 200) {
                                    this.$message({
                                        type: 'success',
                                        message: '设备已删除！'
                                    })
                                    this.getdata()
                                } else {
                                    this.$message({
                                        type: 'info',
                                        message: res.message
                                    })
                                }
                            })
                            .catch(err => {
                                this.loading = false
                                this.$message.error('设备删除失败,请稍后再试！')
                            })
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        })
                    })
            },
            // 选择复选框事件
            selectChange() {
                this.$refs.selectdata = val
            },
            // 关闭编辑、增加弹出框
            closeDialog() {
                this.editFormVisible = false
            },
            closeBatchDialog() {
                this.editBatchFormVisible = false
                this.ids = []
            },
            closeGroupDialog() {
                this.editGroupFormVisible = false
                this.ids = []
            },
            closeDetailDialog() {
                this.editDeviceFormVisible = false
                this.ids = []
            }
        }
    }
</script>

<style scoped>
    .user-search {
        margin-top: 20px;
    }

    .status {
        display: flex;
    }

    .green-bg {
        width: 20px;
        height: 10px;
        border-radius: 5px;
        margin: 5px 5px 0 0px;
        background-color: #0DAC78;
    }

    .red-bg {
        width: 20px;
        height: 10px;
        border-radius: 5px;
        margin: 5px 5px 0 0px;
        background-color: red;
    }

    .grey1-bg {
        width: 20px;
        height: 10px;
        border-radius: 5px;
        margin: 5px 5px 0 0px;
        background-color: #808080;
    }

    .orange-bg {
        width: 20px;
        height: 10px;
        border-radius: 5px;
        margin: 5px 5px 0 0px;
        background-color: #ED7B2F;
    }

    .param-info {
        background-color: #F3F3F3;
        width: 100%;
        height: 120px;
        margin: 20px 0px;
        padding-top: 10px;
    }

    .params-list {
        width: 40%;
        float: left;
        padding-right: 4%;
        margin: 10px 20px;
    }

    .params-list span:nth-child(2) {
        float: right;
        margin-right: 5%;
    }

    .base-title {
        border-left: 3px solid #0052D9;
        padding-left: 10px;
        font-size: 14px;
        margin-top: 20px;
    }

    .base-title span {
        margin-left: 15px;
        font-size: 12px;
    }

    .device-detail {
        padding-top: 20px;
    }

    .device-detail div {
        line-height: 40px;
    }

    .device-detail .right {
        position: absolute;
        right: 5%;
    }

    .blue {
        color: #0052D9;
    }

    .base-title {
        border-left: 3px solid #0052D9;
        padding-left: 10px;
        font-size: 14px;
        margin-top: 20px;
    }

    .base-title span {
        margin-left: 15px;
        font-size: 12px;
    }
</style>


// WEBPACK FOOTER //
// src/views/device/index.vue